export default __webpack_public_path__ + "static/media/pt-dropdown.86604487.webp";